import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import NotificationNotReadIcon from "./NotificationNotReadIcon";

import {greyishBlue900} from "assets/jss/main";

import {NOTIFICATION_TYPE} from "../../../../../index";

NotificationTitle.propTypes = {
    notification: PropTypes.object
};

function NotificationTitle({notification}) {
    function formatTitleByNotificationType(type) {
        if (type === NOTIFICATION_TYPE.IMPORT) {
            const {name, retailerName} = notification.content.values;

            return (
                `${retailerName} - Flux ${name}`
            )
        }

        if (type === NOTIFICATION_TYPE.QUOTE) {
            return <FormattedMessage id={notification.content.message} values={notification.content.values}/>
        }
    }

    return (
        <div style={{
            color: greyishBlue900,
            fontWeight: 600,
            display: 'flex',
        }}>
            {!notification.viewed && (
                <NotificationNotReadIcon />
            )}
            {formatTitleByNotificationType(notification.type)}
        </div>
    );
}

export default NotificationTitle;
